import { getRouteByIdLang } from '../routes';
export const filterRouteParams = (routeId, params) => {
    const route = getRouteByIdLang(routeId);
    const tokens = route?.tokens
        .filter((token) => token?.name)
        .map((token) => token?.name) ?? [];
    return params
        ? tokens.reduce((acc, paramName) => {
            if (typeof params[paramName] !== undefined)
                acc[paramName] = params[paramName];
            return acc;
        }, {})
        : {};
};
//# sourceMappingURL=filterRouteParams.js.map